/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Settings_Users_Invite_ExpiresInputs */

const cs_settings_users_invite_expires = /** @type {(inputs: Settings_Users_Invite_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Platí do ${i?.when}`)
};

const en_settings_users_invite_expires = /** @type {(inputs: Settings_Users_Invite_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Expires {when}" |
*
* @param {Settings_Users_Invite_ExpiresInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_invite_expires = /** @type {((inputs: Settings_Users_Invite_ExpiresInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_Invite_ExpiresInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_invite_expires(inputs)
	return cs_settings_users_invite_expires(inputs)
});